import { render, staticRenderFns } from "./ModifyOrderStatusBulk.vue?vue&type=template&id=b5565170&scoped=true"
import script from "./ModifyOrderStatusBulk.vue?vue&type=script&lang=ts"
export * from "./ModifyOrderStatusBulk.vue?vue&type=script&lang=ts"
import style0 from "./ModifyOrderStatusBulk.vue?vue&type=style&index=0&id=b5565170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5565170",
  null
  
)

export default component.exports